<template>
    <span v-if="countryCodeAvailable">
        <span class="icon">
            <i :class="getFlagIconClass(countryCode)" />
        </span>
        <span v-if="!onlyFlag">
            {{ translate("country." + countryCodeUpperCase) }}
        </span>
    </span>
</template>

<script>
    import translatorMixin from "./translatorMixin";

    export default {
        name: "country",
        mixins: [translatorMixin],
        props: ["countryCode", "onlyFlag", "hasBorder"],
        computed: {
            countryCodeUpperCase() {
                return (this.countryCode || "").toUpperCase();
            },
            countryCodeAvailable() {
                return !!this.countryCode;
            },
        },
        methods: {
            getFlagIconClass(countryCode) {
                let baseClass = "flag-icon flag-icon-" + countryCode.toLowerCase();

                if (this.hasBorder) {
                    baseClass = "has-border " + baseClass;
                }
                return baseClass;
            },
        },
    };
</script>

<style scoped>
    .has-border {
        border: 1px solid #333;
        width: 1.45em;
    }
</style>
